import { add, differenceInMilliseconds, differenceInSeconds, parseISO, sub } from 'date-fns';

export function calculateOvertime(auction: any, offers: any[]) {
  const endPlusOneHour = add(auction.end, { hours: 1 });
  const endMinusOvertimeMinutes = sub(auction.end, { seconds: auction.overtime_seconds });

  let end = auction.end;
  let isInOvertime = false;
  if (differenceInMilliseconds(endMinusOvertimeMinutes, new Date()) < 0) {
    const sortedOffers = offers
      .map((offer) => ({ ...offer, created_at: parseISO(offer.created_at) }))
      .sort((a, b) => a.created_at.getTime() - b.created_at.getTime());

    let lastTime = sub(auction.end, { seconds: auction.overtime_seconds });
    let highestBid = 0;

    for (const offer of sortedOffers) {
      const offerTime = offer.created_at;
      const diffToLastTime = differenceInSeconds(offerTime, lastTime);
      if (diffToLastTime < 0) {
        // ignore old offers
      } else if (diffToLastTime < auction.overtime_seconds && offer.xch_price > highestBid) {
        end = add(offerTime, { seconds: auction.overtime_seconds });
        if (differenceInMilliseconds(end, endPlusOneHour) > 0) {
          end = endPlusOneHour;
        }
        lastTime = offerTime;
        highestBid = offer.xch_price;
      } else {
        break;
      }
    }
    isInOvertime = differenceInMilliseconds(end, auction.end) > 0 && differenceInMilliseconds(end, new Date()) >= 0;
  }
  return { end, isInOvertime };
}
